// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const logo: string[] = ['300 300', `
<image style="overflow:visible;" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgCAIAAABUEpE/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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" transform="matrix(0.36 0 0 0.36 0 0)">
</image>
`]
